import { FormControl } from "@angular/forms";

export function UnitNumberSuffixValidator(control: FormControl, name): any {
	if (control.value) {
		const unitNumberSuffixRegEx = /^[0-9a-zA-Z]+$/;
		const valid = unitNumberSuffixRegEx.test(control.value);
		if (!valid) {
			return {
				unitNumberSuffixInvalid: {
					valid: false,
					message: `Invalid ${name} # S`
				}
			};
		}
		return null;
	}
}
